
      var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgInternationalCallsDesc = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 44,
  height: 44,
  viewBox: "0 0 44 44",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  strokeWidth: 2.75,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "var(--theme-primary, #810ea9)",
  strokeLinejoin: "round",
  d: "M20.693 14.458h17.515M20.693 22.7h17.515"
}), /*#__PURE__*/React.createElement("path", {
  d: "M35.87 27.7A13.852 13.852 0 0 0 39 18.91C39 11.226 32.773 5 25.09 5c-3.313 0-6.357 1.16-8.746 3.094",
  stroke: "#000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M29.298 24.608a36.56 36.56 0 0 0 .43-5.699c0-7.475-2.076-13.536-4.637-13.536-2.56 0-4.636 6.06-4.636 13.536 0 2.025.152 3.945.425 5.67",
  stroke: "#000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.948 25.19a12.775 12.775 0 0 0 5.914 5.888 1.2 1.2 0 0 0 1.186-.09l3.792-2.528c.34-.228.773-.267 1.15-.106l7.093 3.04c.495.21.791.723.726 1.257A7.27 7.27 0 0 1 25.597 39C14.222 39 5 29.778 5 18.403a7.27 7.27 0 0 1 6.35-7.212 1.208 1.208 0 0 1 1.256.726l3.043 7.1c.16.373.122.801-.1 1.14l-2.52 3.85a1.2 1.2 0 0 0-.081 1.183z",
  stroke: "#000",
  strokeLinejoin: "round"
}))));

      const __svgRaw = "<svg width=\"44\" height=\"44\" viewBox=\"0 0 44 44\" xmlns=\"http://www.w3.org/2000/svg\">\r\n    <g stroke-width=\"2.75\" fill=\"none\" fill-rule=\"evenodd\" stroke-linecap=\"round\">\r\n        <path stroke=\"var(--theme-primary, #810ea9)\" stroke-linejoin=\"round\" d=\"M20.693 14.458h17.515M20.693 22.7h17.515\"/>\r\n        <path d=\"M35.87 27.7A13.852 13.852 0 0 0 39 18.91C39 11.226 32.773 5 25.09 5c-3.313 0-6.357 1.16-8.746 3.094\" stroke=\"#000\"/>\r\n        <path d=\"M29.298 24.608a36.56 36.56 0 0 0 .43-5.699c0-7.475-2.076-13.536-4.637-13.536-2.56 0-4.636 6.06-4.636 13.536 0 2.025.152 3.945.425 5.67\" stroke=\"#000\"/>\r\n        <path d=\"M12.948 25.19a12.775 12.775 0 0 0 5.914 5.888 1.2 1.2 0 0 0 1.186-.09l3.792-2.528c.34-.228.773-.267 1.15-.106l7.093 3.04c.495.21.791.723.726 1.257A7.27 7.27 0 0 1 25.597 39C14.222 39 5 29.778 5 18.403a7.27 7.27 0 0 1 6.35-7.212 1.208 1.208 0 0 1 1.256.726l3.043 7.1c.16.373.122.801-.1 1.14l-2.52 3.85a1.2 1.2 0 0 0-.081 1.183z\" stroke=\"#000\" stroke-linejoin=\"round\"/>\r\n    </g>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/international-calls-desc.37d99f4d7003f8ffb71a04b1eacc742d.svg"),
        {
          React: SvgInternationalCallsDesc,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      